import { SegmentedControl } from '@mantine/core'

import type { Period } from '@/api/whatsapiStats'
import { useWhatsApiPeriod } from '@/context/WhatsApiPeriodContext'

const PERIOD_OPTIONS: { value: Period; label: string }[] = [
  { value: '1h', label: '1h' },
  { value: '6h', label: '6h' },
  { value: '24h', label: '24h' },
  { value: '7d', label: '7d' },
  { value: '30d', label: '30d' },
]

interface PeriodSelectorProps {
  size?: 'xs' | 'sm' | 'md'
}

export function PeriodSelector({ size = 'sm' }: PeriodSelectorProps) {
  const { period, setPeriod } = useWhatsApiPeriod()

  return (
    <SegmentedControl
      value={period}
      onChange={(value) => setPeriod(value as Period)}
      data={PERIOD_OPTIONS}
      size={size}
      aria-label="Selecionar período"
    />
  )
}
